import { brandColor } from 'config/brandColor';

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const bookingBar6month = () => ({
  labels,
  datasets: [
    {
      label: '',
      data: [200, 300, 400, 150, 900, 100, 600],
      backgroundColor: brandColor('accent', '#FFA726'),
      barThickness: 30,
    },
  ],
});

export const bookingBar1year = () => ({
  labels,
  datasets: [
    {
      label: '',
      data: [900, 500, 200, 150, 700, 400, 433],
      backgroundColor: brandColor('accent', '#FFA726'),
      barThickness: 30,
    },
  ],
});

export const bookingOptionsBar = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: { display: false },
    title: {
      display: true,
      text: 'Booking Split',
      align: 'start',
      font: {
        size: 20,
        weight: 600,
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: '#282828',
    },
  },
};

export const bookingFilterData = [
  {
    id: 1,
    primaryText: 'Duty Type',
    isRadio: true,
    subItems: [
      { value: 'rental', list: 'Rental', key: 'DutyType' },
      { value: 'airport', list: 'Airport', key: 'DutyType' },
      { value: 'outStation', list: 'OutStation', key: 'DutyType' },
    ],
  },
  {
    id: 2,
    primaryText: 'Status',
    subItems: [
      { value: 'booked', list: 'Booked', key: 'Status' },
      { value: 'alloted', list: 'Alloted', key: 'Status' },
      { value: 'dispatched', list: 'Dispatched', key: 'Status' },
      { value: 'onGoing', list: 'Ongoing', key: 'Status' },
      { value: 'completed', list: 'Completed', key: 'Status' },
      { value: 'cancelled', list: 'Cancelled', key: 'Status' },
    ],
  },
];

export const breadcrumbPaths = [{ name: 'Booking', url: '', className: 'colorBlue cursorDefault' }];
